import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { RegionService } from '../../main-layout/region/region.service';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';


@Component({
  selector: 'app-regionmodal',
  templateUrl: './regionmodal.component.html',
  styleUrls: ['./regionmodal.component.css']
})
export class RegionmodalComponent extends BaseClass implements OnInit {
  CSRFToken='';
  saveTitle = 'Add';
  regionform: FormGroup;
  isEdit: boolean = false;
  existingdetails: any = {};
  onlyView: any;
  isSupportLimited = "N";

  activeFlag = [
    { labelname: 'Active', value: 'Y' },
    { labelname: 'Inactive', value: 'N' }
  ];
  message:GlobalMessage=new GlobalMessage()
  constructor(
    private regionService: RegionService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice:Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title === 'Modify Region') {
      this.isEdit = true;
      this.saveTitle = 'Modify';
      this.existingdetails = dataFromParent.datas;
      this.isSupportLimited = dataFromParent.isSupportLimited;
    }
  }

  ngOnInit() {
    this.formInitialize();
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0]);
    }
  }

  public validation_message = {
    name: [
      { type: 'required', message: 'Region name is required.' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters not allowed ( % and \' ).' },
      { type: 'maxlength', message: 'Maximum length exceeded' }
    ] 
  };

  patchValueForms(data) {
    this.regionform.patchValue({
      name: data?.name,
      activeflag: data?.activeflag
    });
  }

  formInitialize() {
    this.regionform = this.fb.group({ 
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR)])],
      activeflag: ['Y'] // Ensure this field is included if needed
    });
  }

  add() {
    if (this.regionform.invalid) {
      this.validateAllFormFields(this.regionform);
      return; // Exit early if the form is invalid
  }
  else{
    if (this.saveTitle === 'Modify') {
      this.modify(this.regionform.value);
    } else {
      if (this.regionform.invalid) {
        this.validateAllFormFields(this.regionform);
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: "Don't Save"
        }).then((value) => {
          if (value.isConfirmed) {
            let data = this.regionform.value;
            data['csrftoken']=this.CSRFToken
            // this.regionService.addRegion(this.regionform.value).subscribe(
            //   () => {
            //     Swal.fire("Saved!", "", "success").then(() => {
            //       this.ref.close();
            //     });
            //   },
            //   error => {
            //     Swal.fire({
            //       icon: "error",
            //       title: "Oops...",
            //       text: error.error.error,
            //       footer: `Error status is: ${error.status}`
            //     });
            //   }
            // );
            this.regionService.addRegion(this.regionform.value).subscribe({
            next: (response: any) => { 
    
              if (response?.response === 'exists') {
                Swal.fire("Region already exists!", "", "error");
              } else {
                Swal.fire("Region added successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });}
            }
                });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      }
    }
  }}

  modify(data: any) {
    
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: "Don't Save"
    }).then((value) => {
      if (value.isConfirmed) {
        let data = this.regionform.value;
        data['csrftoken']=this.CSRFToken
        data.regionid = this.existingdetails[0].regionid; // Ensure correct assignment

        // this.regionService.updateRegion(data).subscribe(
        //   () => {
        //     Swal.fire("Updated!", "", "success").then(() => {
        //       this.ref.close();
        //     });
        //   },
        //   error => {
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: error.error.error,
        //       footer: `Error status is: ${error.status}`
        //     });
        //   }
        // );
        this.regionService.updateRegion(data).subscribe({
            next: (response: any) => { 
    
              if (response?.response === 'exists') {
                Swal.fire("Region already exists!", "", "error");
              } else {
                Swal.fire("Region modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });}
            }
                });
      } else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }

        gettoken(){
          this.CSRFToken='';
           this.utilityservice.getCSRFtoken().subscribe(res=>{
           this.CSRFToken=res.csrf;
          },error=>{
            Swal.fire(error.error.message,'','error');
          });
        }  
}
